<template>
    <div id="body">
        <menus title="Tools"></menus>
        <div id="app">
            <p>这里是 szerr 密码生成器，默认屏蔽了一些字体不容易辨认的字符。</p>
            <p>这是一个纯前端应用，你的数据不会储存到服务器中。</p>
            <input v-model="pwd" id="pwdInput" />
            <div style="justify-content: space-between;display: flex;">
                <div style="margin:auto 0px;">长度：</div>
                <input
                    class="length"
                    type="range"
                    v-model="len"
                    min="4"
                    max="50"
                    v-on:input="gener"
                />
                <div style="margin:auto 0px;">{{ len }}</div>
                <span @click="gener()">
                    <sbuttonVue class="pwdButton">生成密码</sbuttonVue>
                </span>
                <span @click="copyPwd(pwd)">
                    <sbuttonVue class="pwdButton">复制密码</sbuttonVue>
                </span>
            </div>包含：
            <checkboxVue
                class="rangeItem"
                v-bind:value="hasMember"
                v-on:click="checkboxHeader('hasMember', $event)"
            >数字</checkboxVue>
            <checkboxVue
                class="rangeItem"
                v-bind:value="hasUpLetter"
                v-on:click="checkboxHeader('hasUpLetter', $event)"
            >大写字母</checkboxVue>
            <checkboxVue
                class="rangeItem"
                v-bind:value="hasLowLetter"
                v-on:click="checkboxHeader('hasLowLetter', $event)"
            >小写字母</checkboxVue>
            <checkboxVue
                class="rangeItem"
                v-bind:value="hasEasySymbol"
                v-on:click="checkboxHeader('hasEasySymbol', $event)"
            >,.</checkboxVue>
            <checkboxVue
                class="rangeItem"
                v-bind:value="hasSymbol"
                v-on:click="checkboxHeader('hasSymbol', $event)"
            >其他符号</checkboxVue>
            <br />排除：
            <checkboxVue
                class="rangeItem"
                v-bind:value="hasExclude"
                v-on:click="checkboxHeader('hasExclude', $event)"
            >
                <input v-model="exclude" />
            </checkboxVue>
            <br />存储配置
            <checkboxVue class="rangeItem" v-bind:value="saveConfig" v-on:click="setSaveConfig()"></checkboxVue>配置存储在 localStorage 中，点击这里 ->
            <span @click="clearConfig()">
                <sbuttonVue class="pwdButton">清除配置</sbuttonVue>
            </span>

            <p>
                本次密码生成历史，点击任意条目复制，点此 ->
                <span @click="clearHistory">
                    <sbuttonVue class="pwdButton">清空</sbuttonVue>
                </span>
            </p>
            <div class="pwdHistory">
                <div v-for="p in pwdHistory" v-bind:key="p" @click="copyPwd(p)">
                    <active class="pwdItem">{{ p }}</active>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import sbuttonVue from "../components/sbutton.vue"
import checkboxVue from "../components/checkbox.vue"
import menus from '@/components/menus.vue'
import active from '@/components/active.vue'
export default {
    components: {
        sbuttonVue,
        checkboxVue,
        menus,
        active,
    },
    data: function () {
        return {
            hasMember: true,
            hasUpLetter: true,
            hasLowLetter: true,
            hasSymbol: true,
            hasExclude: true,
            hasEasySymbol: true,
            saveConfig: false,
            exclude: "014IOl|\\",
            memberRange: "0123456789",
            upLetterRange: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
            lowLetterRange: "abcdefghijklmnopqrstuvwxyz",
            symbol: ")!\"#$%&'()*+-/:;<:>?@[\\]^_`{}~",
            easySymbol: ",.",
            scopeLi: [], // 随机域的数组
            range: '',
            len: 8,
            pwd: '',
            pwdHistory: [],
            // 本地配置key
            localConfig: ['hasMember', 'hasUpLetter', 'hasLowLetter', 'hasSymbol', 'hasExclude', 'hasEasySymbol', 'len', 'exclude'],
            // 源配置
            sourceConfig: { 'hasMember': true, 'hasUpLetter': true, 'hasLowLetter': true, 'hasSymbol': true, 'hasExclude': true, 'hasEasySymbol': true, 'len': 8, 'exclude': "014IOl|\\" },
        }
    },
    beforeMount: function () {
        for (let k of this.localConfig) {
            let i = localStorage.getItem(k)
            if (i == null) {
                this[k] = this.sourceConfig[k]
            } else {
                this.saveConfig = true
                if (k == 'exclude') {
                    this[k] = i
                } else {
                    this[k] = JSON.parse(i)
                }
            }
        }
        this.gener()
    },
    methods: {
        checkboxHeader: function (o, v) {
            if (o == "hasMember") {
                this.hasMember = v
            } else if (o == "hasUpLetter") {
                this.hasUpLetter = v
            } else if (o == "hasLowLetter") {
                this.hasLowLetter = v
            } else if (o == "hasEasySymbol") {
                this.hasEasySymbol = v
            } else if (o == "hasSymbol") {
                this.hasSymbol = v
            }
            this.gener()
        },
        shuffle: function (array) {
            for (let i = array.length - 1; i > 0; i--) {
                let j = Math.floor(Math.random() * (i + 1));
                let temp = array[i];
                array[i] = array[j];
                array[j] = temp;
            }
            return array;
        },
        exc: function (li) {
            let r = li
            for (let i of this.exclude) {
                r = r.replace(i, '')
            }
            return r
        },
        flushRange: function () {
            this.range = ""
            this.scopeLi = []
            if (this.hasMember) {
                let r = this.exc(this.memberRange)
                this.range += r
                this.scopeLi.push(r)
            }
            if (this.hasUpLetter) {
                let r = this.exc(this.upLetterRange)
                this.range += r
                this.scopeLi.push(r)
            }
            if (this.hasLowLetter) {
                let r = this.exc(this.lowLetterRange)
                this.range += r
                this.scopeLi.push(r)
            }
            if (this.hasEasySymbol) {
                let r = this.exc(this.easySymbol)
                this.range += r
                this.scopeLi.push(r)
            }
            if (this.hasSymbol) {
                let r = this.exc(this.symbol)
                this.range += r
                this.scopeLi.push(r)
            }
        },

        gener: function () {
            let pwd = ""
            this.flushRange()
            // 计算每个域占总域的比
            for (let i of this.scopeLi) {
                pwd += i[Math.floor(Math.random() * i.length)]
            }
            pwd = pwd.slice(0, this.len)
            for (let i = pwd.length; i < this.len; i++) {
                let r = Math.floor(Math.random() * this.range.length)
                let l = this.range[r]
                if (l) {
                    pwd += l
                }
            }
            if (this.pwd) {
                this.pwdHistory.push(this.pwd)
            }
            this.pwd = this.shuffle(pwd.split('')).join('')
            if (this.saveConfig) {
                for (let k of this.localConfig) {
                    console.log(k, this[k])
                    localStorage.setItem(k, this[k])
                }
            }
        },

        checkMember: function () {
            this.memberRange = !this.memberRange
        },

        copyPwd: function (pwd) {
            navigator.clipboard.writeText(pwd)
        },

        setSaveConfig: function () {
            this.saveConfig = true
        },

        clearConfig: function () {
            localStorage.clear()
            for (let k of this.localConfig) {
                this[k] = this.sourceConfig[k]
            }
            this.saveConfig = false
        },
        clearHistory: function () {
            this.pwdHistory = []
        }
    }
}
</script>

<style>
#body {
    height: 100%;
    margin: auto;
}
#pwdInput {
    height: 32px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    width: 100%;
    margin: auto;
    display: block;
}
#app {
    max-width: 800px;
    margin: auto;
}
.length {
    width: 470px;
}
.rangeItem {
    margin-right: 20px;
    display: inline-block;
}
.pwdButton {
    margin-left: 2px;
    width: 80px;
}
.pwdItem {
    display: block;
}
</style>